import { FC } from "react";
import styled from "@emotion/styled";
import { CitationChip } from "./CitationChip";

interface SourceRunCitationsProps {
  visibleSourceIds: readonly string[];
  maxWidth?: string;
}

export const SourceRunCitations: FC<SourceRunCitationsProps> = ({
  visibleSourceIds,
  maxWidth = "min(220px, 45%)",
}) => {
  if (visibleSourceIds.length === 0) {
    return null;
  }

  return (
    <SourceSlot $maxWidth={maxWidth}>
      <InlineSources>
        {visibleSourceIds.map(noteId => (
          <CitationChip key={noteId} noteId={noteId} />
        ))}
      </InlineSources>
    </SourceSlot>
  );
};

const SourceSlot = styled.div<{ $maxWidth: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  align-self: center;
  flex: 0 1 auto;
  max-width: ${({ $maxWidth }) => $maxWidth};
  min-width: 0;
  min-height: 22px;
`;

const InlineSources = styled.div`
  display: inline-flex;
  align-items: center;
  align-content: flex-start;
  flex-wrap: wrap;
  flex: 0 1 auto;
  justify-content: flex-start;
  gap: 4px;
  max-width: 100%;
  min-width: 0;

  > * {
    flex: 0 1 auto;
  }
`;
